var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.75V15.25H14V16.75H6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.25H10V12.75H14V11.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18934 0.25H18.5C18.9142 0.25 19.25 0.585786 19.25 1V21C19.25 21.4142 18.9142 21.75 18.5 21.75H1.5C1.08579 21.75 0.75 21.4142 0.75 21V7.68934L8.18934 0.25ZM17.75 1.75H9.25V8.75H2.25V20.25H17.75V1.75ZM3.31066 7.25H7.75V2.81066L3.31066 7.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReports);
export default __webpack_public_path__ + "static/media/ic_reports.2e20f8c95f8c3a495a1cda5b76ca55d0.svg";
export { ForwardRef as ReactComponent };